module.exports = __webpack_public_path__ + "img/mini-cart-icon-black-new.7f09914c.svg";